var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0827 7.50008C12.0827 8.65066 11.1499 9.58341 9.99935 9.58341C8.84877 9.58341 7.91602 8.65066 7.91602 7.50008C7.91602 6.34949 8.84877 5.41675 9.99935 5.41675C11.1499 5.41675 12.0827 6.34949 12.0827 7.50008Z",
    stroke: "#F1F1F1",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0472 14.5781C10.7661 14.8487 10.3904 15.0001 9.99952 15.0001C9.60852 15.0001 9.23285 14.8487 8.95177 14.5781C6.37793 12.0841 2.92867 9.298 4.61077 5.25319C5.52027 3.06618 7.70347 1.66675 9.99952 1.66675C12.2955 1.66675 14.4787 3.06619 15.3882 5.25319C17.0682 9.29291 13.6273 12.0927 11.0472 14.5781Z",
    stroke: "#F1F1F1",
    strokeWidth: 1.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 16.6667C15 17.5872 12.7614 18.3334 10 18.3334C7.23857 18.3334 5 17.5872 5 16.6667",
    stroke: "#F1F1F1",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.461a9c2cdc3a273695559bc1d7f39962.svg";
export { ForwardRef as ReactComponent };